import React, { useCallback } from 'react';
import DialogContainer, { DialogButton } from '../../components/AlertDialog/DialogContainer';
import { VoicemailsDialogProps } from './utils';
import { useStyles } from './utils/VoicemailsDialog.utils';
import { useVoicemails } from './hooks';
import VoicemailsContent from './components/VoicemailsContent';
import { useDispatch } from 'react-redux';
import { actions } from '../../store';
import { initialState } from '../../store/reducers/calls/reducer';

const VoicemailsDialog: React.VFC<VoicemailsDialogProps> = ({
    isOpen,
    toggleVisibility,
    extensionId,
    extensionName,
    i_account,
    fetchData: externalFetchData,
    faxMode,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const voicemails = useVoicemails({
        i_account,
        extensionId,
        extensionName,
        onDataRefresh: externalFetchData,
        faxMode,
    });

    const { t, isLoadingVoicemails, resetForm } = voicemails;

    const stopAudio = useCallback(() => {
        dispatch(actions.internalUpdateRecordingsPlayingState({ ...initialState.internalRecordingsPlayer }));
        dispatch(actions.updateRecordingsPlayingState({ ...initialState.recordingsPlayer }));
    }, [dispatch]);

    const onCloseDialogClick = useCallback(() => {
        resetForm();
        stopAudio();
        toggleVisibility?.();
    }, [resetForm, toggleVisibility, stopAudio]);

    return (
        <DialogContainer
            isOpen={isOpen}
            dataQa="voicemails-dialog"
            onClose={stopAudio}
            header={t(
                faxMode
                    ? 'screens:voicemails.faxesDialogTitle'
                    : 'screens:voicemails.voicemailsDialogTitle',
                {
                    extensionNumber: extensionId,
                    name: extensionName ?? t('screens:autoAttendants.unnamed'),
                },
            )}
            // @ts-ignore
            headerClass={classes.header}
            // @ts-ignore
            className={classes.modalContainer}
            dialogActionsButtons={[
                <DialogButton
                    // @ts-ignore
                    className={classes.primaryActionButton}
                    key="close"
                    label={t('common:close')}
                    onClick={onCloseDialogClick}
                />,
            ]}
            showLoader={isLoadingVoicemails}
        >
            <VoicemailsContent voicemails={voicemails} />
        </DialogContainer>
    );
};

export default VoicemailsDialog;